import React from "react";
import { STATUS } from "@/lib/helpers";
import { cn } from "@/lib/utils";

export default function StatusBadge({ status }) {
  const s = STATUS[status] || STATUS.todo;
  return (
    <span data-testid={`status-${status}`} className={cn("inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full", s.cls)}>
      <span className={cn("h-1.5 w-1.5 rounded-full", s.dot)} /> {s.label}
    </span>
  );
}
